import { Button } from "@/components/ui/button";
import { AnimateOnScroll } from "@/components/AnimateOnScroll";
import { ArrowRight } from "lucide-react";

interface CTASectionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonOnClick?: () => void;
  gradient: string; // e.g., "from-blue-600 via-indigo-600 to-purple-600"
  buttonTextColor: string; // e.g., "blue" for text-blue-700
}

export const CTASection = ({
  title,
  description,
  buttonText,
  buttonOnClick,
  gradient,
  buttonTextColor,
}: CTASectionProps) => {
  return (
    <section className="py-12 md:py-20 relative overflow-hidden">
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient}`} />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }} />
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <AnimateOnScroll animation="fade-up">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 px-2">
              {title}
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white/80 mb-6 md:mb-8 leading-relaxed px-2">
              {description}
            </p>
            <Button 
              size="lg" 
              className={`bg-white text-${buttonTextColor}-700 hover:bg-${buttonTextColor}-50 px-6 py-5 sm:px-8 sm:py-6 text-base sm:text-lg font-semibold shadow-2xl`}
              onClick={buttonOnClick}
            >
              {buttonText}
              <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
            </Button>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};
